import axios from 'axios'

const NOW_API_URL =
  'https://now.mediawaves.de/now/api/info/shop-apotheke.com?zipCode='

export const checkNowValitidyByZipCode = async (
  code: string
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${NOW_API_URL}${code}`)
      .then(({ data }) => {
        if (data.services.servicesNow.length) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const checkAndGetUserZipCode = async (): Promise<string> => {
  return new Promise(resolve => {
    const zipCodeFromSession = sessionStorage.getItem('zipCode') || ''

    resolve(zipCodeFromSession)
  })
}
